import { render, staticRenderFns } from "./BinderTemplate.vue?vue&type=template&id=e782bc0c&"
import script from "./BinderTemplate.vue?vue&type=script&lang=js&"
export * from "./BinderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports